import React, { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/auth/prijava';
import Layout from '../layout/Layout';
import Unauthorized from '../pages/auth/neovlascen';
import { useAuth } from '../context/useAuth';
import ForgotPassword from '../pages/auth/zaboravljena-sifra';
import ChangePassword from '../pages/auth/promenite-sifru';
import NewPassword from '../pages/auth/nova-sifra';
import SuccessfulPasswordChange from '../pages/auth/promenjena-sifra';
import ResetPassword from '../pages/auth/reset-password';
import PropTypes from 'prop-types';
import { adminRoles, otherRoles, agentRoles } from './roles';

// Every role that may load the admin shell at all, i.e. everything except a plain client.
const STAFF_ROLES = [...adminRoles, ...otherRoles, ...agentRoles];

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  return user ? children : <Navigate to="/login" replace />;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null;

  // The last operand used to be the bare string 'clinic_owner', which is always truthy and
  // collapsed the whole check to "is signed in" - any client could open the admin shell.
  // The shell is for staff roles; per-route access is then enforced by ProtectedRoute.
  return user && STAFF_ROLES.includes(user.role) ? (
    children
  ) : (
    <Navigate to="/neovlascen" replace />
  );
};

const AppRouter = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/neovlascen" element={<Unauthorized />} />
    <Route path="/zaboravljena-sifra" element={<ForgotPassword />} />
    <Route path="/promenite-sifru" element={<ChangePassword />} />
    <Route path="/nova-sifra" element={<NewPassword />} />
    <Route path="/promenjena-sifra" element={<SuccessfulPasswordChange />} />
    {/* Target of the API's password-reset email redirect; public, for all roles. */}
    <Route path="/reset-password" element={<ResetPassword />} />

    <Route
      path="/*"
      element={
        <PrivateRoute>
          <AdminRoute>
            <Layout />
          </AdminRoute>
        </PrivateRoute>
      }
    />
  </Routes>
);

PrivateRoute.propTypes = {
  children: PropTypes.node,
};

AdminRoute.propTypes = {
  children: PropTypes.node,
};

export default AppRouter;
